<template>
  <div id="sign">
    <div>
      <img src="../assets/logo-500.png" alt="am center logo" width="80px">
      <span class="x-bg">X</span>
    </div>
    <el-tabs :value="currentTab" class="sign-body">
      <el-tab-pane label="Sign In" name="signIn">
        <div class="sign-in-wrapper">
          <!-- <h3>Sign In</h3> -->
          <el-alert type="error" :title="signError" center show-icon v-show="signError"></el-alert>
          <el-alert :title="signInError" type="error" center show-icon v-show="signInError"></el-alert>
          <el-alert :title="signInTip" type="success" center show-icon v-show="signInTip"></el-alert>

          <!-- Sign in, input email -->
          <div class="input-wrapper">
            <div class="input-label">Email</div>
            <el-input placeholder="jhon@example.com" v-model="signForm.email" @focus="clearError('email')" :class="formError.email === '' ? '':'input-red'" inputmode="email"></el-input>
            <div class="input-error">{{formError.email}}</div>
          </div>

          <!-- Sign in, input password -->
          <div class="input-wrapper">
            <div class="input-label" style="margin-bottom: 0">
              <span>Password</span>
              <span @click="resetPassword()" class="reset-password">Forget password?</span>
            </div>
            <el-input placeholder="At least 6 character" v-model="signForm.password" type="password" @focus="clearError('password')" :class="formError.password === '' ? '':'input-red'" :show-password="true"></el-input>
            <div class="input-error">{{formError.password}}</div>
          </div>

          <div class="button-area">
            <el-button round style="width: 100%" type="primary" @click="signInButton()" v-show="!signing" :disabled="!hasNetwork">{{hasNetwork ? 'Sign In' : 'Nrework Is Requried'}}</el-button>
            <!-- <looping-rhombuses-spinner v-if="signing" :animation-duration="2500" :rhombus-size="15" color="#f57c00"/> -->
            <half-circle-spinner style="margin: auto" v-if="signing" :animation-duration="1000" :size="50" color="#f57c00"/>
            <!-- <a @click="currentTab = 'singUp'">Sign Up</a> -->
          </div>

          <div class="recapcha-term" v-if="hasNetwork">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Sign Up" name="signUp">
        <div class="sign-up-wrapper">
          <!-- <h3>Sign Up</h3> -->
          <el-alert type="error" :title="signError" center show-icon v-show="signError"></el-alert>

          <div v-show="signUpError" class="sign-up-fail">{{ signUpError }}</div>

          <!-- Sign up, email input -->
          <div class="input-wrapper">
            <div class="input-label">Email</div>
            <el-input placeholder="jhon@example.com" v-model="signForm.email" @focus="clearError('email')" :class="formError.email === '' ? '':'input-red'" :disabled="hasEmail"></el-input>
            <div class="input-error">{{formError.email}}</div>
          </div>

          <!-- Sign up. passwrd input -->
          <div class="input-wrapper">
            <div class="input-label">Passwrod</div>
            <el-input placeholder="At least 6 character" v-model="signForm.password" type="password" @focus="clearError('password')" :class="formError.password === '' ? '':'input-red'" :show-password="true"></el-input>
            <div class="input-error">{{formError.password}}</div>
          </div>

          <!-- Sign up. confirm passwrd input -->
          <div class="input-wrapper">
            <div class="input-label">Confirm Password</div>
            <el-input placeholder="Please enter your password again" v-model="signForm.rePassword" type="password" @focus="clearError('rePassword')" :class="formError.rePassword === '' ? '':'input-red'"></el-input>
            <div class="input-error">{{formError.rePassword}}</div>
          </div>

          <!-- Sign up. first name input -->
          <div class="input-wrapper">
            <div class="input-label">First Name</div>
            <el-input placeholder="Emily" v-model="signForm.name.first" @focus="clearError('first')" :class="formError.name.first === '' ? '':'input-red'"></el-input>
            <div class="input-error">{{formError.name.first}}</div>
          </div>

          <!-- Sign up. last name input -->
          <div class="input-wrapper">
            <div class="input-label">Last Name</div>
            <el-input placeholder="Lightman" v-model="signForm.name.last" @focus="clearError('last')" :class="formError.name.last === '' ? '':'input-red'"></el-input>
            <div class="input-error">{{formError.name.last}}</div>
          </div>

          <!-- Sign up. invitation code input -->
          <div class="input-wrapper">
            <div class="input-label">Invitation Code</div>
            <el-input placeholder="Invitaion Code From Your Invitation" v-model="signForm.invitationCode" :disabled="hasInvi"></el-input>
            <div class="input-error">{{formError.invitationCode}}</div>
          </div>

          <div class="button-area">
            <el-button style="width: 100%" round type="primary" @click="signUpButton()" v-show="!signing" :disabled="!hasNetwork">{{hasNetwork ? 'Sign Up' : 'Nrework Is Requried'}}</el-button>
            <!-- <looping-rhombuses-spinner v-if="signing" :animation-duration="2500" :rhombus-size="15" color="#f57c00"/> -->
            <half-circle-spinner style="margin: auto" v-if="signing" :animation-duration="1000" :size="50" color="#f57c00"/>
            <!-- <a href="#" @click="currentTab = 'singIn'">Sign In</a> -->
          </div>

          <div class="recapcha-term" v-if="hasNetwork">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import is from 'is_js'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'Sign',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      currentTab: this.$route.query.invi ? 'signUp' : 'signIn',
      signForm: {
        // the user input is shared between sign in and sign up
        email: this.$route.query.email ? this.$route.query.email : '',
        password: '',
        rePassword: '',
        name: {
          first: '',
          last: ''
        },
        invitationCode: this.$route.query.invi ? this.$route.query.invi : ''
      },
      formError: {
        email: '',
        password: '',
        rePassword: '',
        name: {
          first: '',
          last: ''
        },
        invitationCode: ''
      },
      signUpError: '',
      signInError: '',
      signInTip: ''
    }
  },
  computed: {
    signError: function () {
      return this.$store.state.signError
    },
    signing: function () {
      return this.$store.state.signing
    },
    hasInvi: function () {
      return Boolean(this.$route.query.invi)
    },
    hasEmail: function () {
      return Boolean(this.$route.query.email)
    },
    hasNetwork: function () {
      return this.$store.state.networkStatus
    }
  },
  methods: {
    resetPassword: async function () {
      if (!is.email(this.signForm.email)) {
        this.formError.email = 'Please input a valid email'
      }
      let sentResult = await this.$store.dispatch('resetPassword', this.signForm.email)
      if (sentResult.success) {
        this.signInTip = `A password reset email has been sent to ${this.signForm.email}`
      } else {
        this.signInError = sentResult.error
      }
    },
    signInButton: async function () {
      if (!this.hasNetwork) {
        this.signInError = 'Network connection is required'
        return
      }
      if (!this.verifyForm('signIn')) {
        return
      }
      let recaptchaToken = this.$store.state.isProduction ? await this.$recaptcha('sign_in') : ''
      let signInRequest = {
        type: 'EMAIL',
        email: this.signForm.email.toLowerCase(),
        password: this.signForm.password,
        token: recaptchaToken
      }
      this.$store.dispatch('signInUser', signInRequest)
    },
    signUpButton: async function () {
      if (!this.hasNetwork) {
        this.signUpError = 'Network connection is required'
        return
      }
      if (!this.verifyForm('signUp')) {
        return
      }
      let recaptchaToken = this.$store.state.isProduction ? await this.$recaptcha('sign_up') : ''
      let signUpRequest = {
        type: 'EMAIL',
        email: this.signForm.email.toLowerCase(),
        name: this.signForm.name,
        password: this.signForm.password,
        token: recaptchaToken,
        invitationCode: this.signForm.invitationCode
      }
      this.$store.dispatch('signUpUser', signUpRequest)
    },
    verifyForm: function (tab) {
      let passed = true
      if (tab === 'signIn') {
        if (!is.email(this.signForm.email.toLowerCase())) {
          passed = false
          this.formError.email = 'Please enter valid email address'
        }
        if (this.signForm.password.length < 6) {
          passed = false
          this.formError.password = 'At least 6 charecters required'
        }
      } else if (tab === 'signUp') {
        if (!is.email(this.signForm.email.toLowerCase())) {
          passed = false
          this.formError.email = 'Please enter valid email address'
        }
        if (this.signForm.password.length < 6) {
          passed = false
          this.formError.password = 'At least 6 charecter is required'
        }
        if (this.signForm.password !== this.signForm.rePassword) {
          passed = false
          this.formError.rePassword = 'Password entered does not match'
        }
        if (is.empty(this.signForm.name.first)) {
          passed = false
          this.formError.name.first = 'Please enter your first name'
        }
        if (is.empty(this.signForm.name.last)) {
          passed = false
          this.formError.name.last = 'Please enter your last name'
        }
        if (is.empty(this.signForm.invitationCode)) {
          passed = false
          this.formError.invitationCode = 'Please enter your invitation code'
        }
      } else {
        console.warn('Unknown verify target =>', tab)
        passed = false
      }
      return passed
    },
    clearError: function (target) {
      switch (target) {
        case 'email':
          this.formError.email = ''
          break
        case 'password':
          this.formError.password = ''
          break
        case 'rePassword':
          this.formError.rePassword = ''
          break
        case 'first':
          this.formError.name.first = ''
          break
        case 'last':
          this.formError.name.last = ''
          break
        default:
          console.warn('clear error failed, unknow input target =>', target)
      }
    },
    verifyReCaptcha: async function (action) {
      let reCaptchaToken = await this.$recaptcha(action)
      // console.log('reCaptcha client respnese =>', reCaptchaToken)
      let verifyResult = await this.$store.dispatch('verifyReCaptchaToken', reCaptchaToken)
      // console.log('reCaptcha remote verify result =>', verifyResult.data)
      return verifyResult.data.pass
    },
    verifyReCaptchaToken: async function (token) {
      return this.$store.dispatch('signInUserByEmail', token)
    },
    signInUserByEmail: async function (email, password) {
      return this.$store.dispatch('signInUserByEmail', email.toLowerCase(), password)
    },
    signUpUserByEmail: async function (userInfo) {
      return this.$store.dispatch('signUpUserByEmail', userInfo)
    },
    createPendingUser: async function (user) {
      return this.$store.dispatch('createPendingUser', user)
    }
  }
}

</script>

<style>
body {
  font-size: 17px;
}
a {
  color: #808080;
}
#tab-signUp {
  font-weight: 600;
}
#tab-signIn {
  font-weight: 600;
}
#sign {
  width: 500px;
  margin: 12vh auto 12vh auto;
  box-sizing: border-box;
  padding: 40px 24px;
  border: solid 2px #f0f0f0;
  border-radius: 20px;
  background-color: #ffffff;
}
.x-bg {
  font-family: 'ZCOOL XiaoWei', serif;
  font-size: 36px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.05);
}
.sign-body {
  margin-top: 16px;
}
.input-wrapper {
  margin-top: 4px;
  margin-bottom: 16px;
  margin-right: 4px;
}
.input-label {
  font-size: 15px;
  color: #808080;
  margin-bottom: 6px;
}
.recapcha-term {
  width: 85%;
  font-size: 14px;
  line-height: 21px;
  margin: 40px auto 0 auto;
  color: #808080;
  text-align: center;
}
.button-area {
  margin-top: 24px;
}
.input-error {
  font-size: 16px;
  color: #c62828;
  line-height: 24px;
  margin-top: 4px;
  margin-left: 4px;
}
.input-red {
  border: solid 1.2px red;
  border-radius: 5px;
}
.sign-error {
  font-size: 15px;
  line-height: 25px;
  color: #c62828;
  font-weight: bold;
  margin-bottom: 10px;
  background-color: rgba(255, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 8px 12px;
  border-radius: 5px;
}
.reset-password {
  float: right;
  font-size: 15px;
  text-decoration: underline;
  color: #409eff;
  font-weight: bold;
  padding-bottom: 6px;
}

@media screen and (max-width: 991px) {
  #sign {
    width: 90vw;
    margin: 5vh auto 5vh auto;
    padding: 20px;
    border-radius: none;
  }
}
</style>
